(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignFormatterV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-formatter-v1', context);

      $('body').addClass('thewink-hp-redesign');

      // Ensure we have the "section-thewink-redesign" body class and remove the "section-thewink" body class from the new "The Wink" 2.0 pages
      if (!$('body').hasClass('section-thewink-redesign') && $('body').hasClass('section-thewink')) {
        $('body').removeClass('section-thewink');
        $('body').addClass('section-thewink-redesign');
      }

      formatter.once('eh-thewink-hp-redesign-formatter').each(function () {
        var thisFormatter = $(this);
        // Infinite scroll (Load More)
        var iNum = thisFormatter.data('init-items'), // Initial number of visible items
          sNum = thisFormatter.data('subs-items'), // Number of items to load when "load more" is clicked
          cNum = iNum, // Current # of rows visible
          tNum = thisFormatter.find('.infinite-scroll__block').length, // Total # of rows
          $lm = $('.js-infinite-scroll__load-more', thisFormatter); // "Load More" button element

        $lm.once().on('click', function(e) {
          e.preventDefault();

          var $button = $(this),
            start = cNum,
            end = cNum + sNum;

          if (end > tNum) {
            end = tNum;
          }

          var $element = $(), // placeholder element object
            content = {}, // placeholder content variable
            curPos = {}, // placeholder variable for the current position of an element
            startPos = 0, // placeholder variable for the top of the first element we're showing
            endPos = 0; // placeholder variable for the bottom of the last element we're showing

          for (var i = start; i < end; i++) {
            $element = thisFormatter.find('.js-infinite-scroll__block[data-index=' + i + ']');

            // Add the content to the element
            content = $.parseJSON($element.data('content'));
            $element.html(content);

            // Get the top of the first element
            if (i == start) {
              startPos = $element.offset();
              startPos = Math.round(startPos.top);
            }

            // Get the bottom of the last element
            if (i == end - 1) {
              endPos = $element.offset();
              endPos = endPos.top;
              endPos = Math.round(endPos + $element.outerHeight(true));
            }

            // Initialize any javascript attached to the template
            Drupal.attachBehaviors($element, settings);

            // Add top margin to each loaded element on PC and tablets
            // if (!site.client.isMobile) {
            // $element.css({'margin-top':'40px'});
            // }
          }

          // Scroll by the # of pixels from the top of the first item we're showing,
          // to the bottom of the last element
          if (startPos != 0 && endPos != 0) {
            // var totalPixels = endPos - startPos;
            // var y = $(window).scrollTop();
            var nodeId = $element.find('.node').attr('id');

            $('html, body').animate({
              scrollTop: $('#' + nodeId).offset().top
            }, 600);
          }

          // Update the total # of visible items to be the new amount
          cNum = end;

          // Hide this button if all of the rows have been loaded
          if (cNum == tNum) {
            $button.addClass('hidden');
          }

          return false;
        });
        // Ends Infinite scroll (Load More)
      });
    }
  };
})(jQuery);
